/*
 * dashboard (page)
 */
import { Container, PageHeader, Page } from "@emr/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import { MapPin, User } from "lucide-react"
import { DashboardCard } from "../components/dashboard-card"
import { authPageLoader } from "../utils/auth.utils"

export const Route = createFileRoute("/dashboard")({
	component: DashboardPage,
	loader: authPageLoader,
})

function DashboardPage() {
	return (
		<Page>
			<Container width={"xxxl"} padding={"lg"} gap={"lg"}>
				<PageHeader title={"EMR Dashboard"} />

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					<DashboardCard
						title="Account"
						description="Manage your account settings and preferences."
						to="/auth/account"
						icon={<User className="w-8 h-8" />}
						gradient="from-slate-500 to-slate-300"
					/>
					<DashboardCard
						title="Addresses"
						description="View and update your addresses on file."
						to="/patient/address"
						icon={<MapPin className="w-8 h-8" />}
						gradient="from-blue-500 to-blue-300"
					/>
				</div>
			</Container>
		</Page>
	)
}
